import { Controller } from "stimulus"
import tinymce from 'tinymce/tinymce'
import 'tinymce/icons/default'
import 'tinymce/themes/silver'
import 'tinymce/plugins/link'
import 'tinymce/plugins/lists'

export default class extends Controller {
  connect() {
    tinymce.init({
      target: this.element,
      plugins: 'link lists',
      toolbar: "undo redo | styleselect | bold italic underline strikethrough | subscript superscript | alignleft aligncenter alignright alignjustify | bullist numlist | indent outdent | link ",
      convert_urls: false,
    }).then((editors) => { this.tinymce = editors[0] })
  }

  disconnect() {
    this.tinymce.destroy()
    // After destroy the textarea is still left at `display: none`, we will reset it here
    this.element.style.display = ''
  }
}